{
  "nav_dashboard": "Dashboard",
  "nav_orders": "Orders",
  "nav_orders_export": "Orders Export",
  "nav_inventory": "Inventory",
  "nav_split": "Split Orders",
  "nav_returns": "Returns",
  "nav_sino": "Sino",
  "nav_inbound": "Inbound Report",
  "nav_notifications": "Notifications",
  "nav_campaigns": "Campaigns",
  "nav_promotions": "Promotions",
  "nav_users": "Users",
  "nav_audit": "Audit Log",
  "grp_operations": "Operations",
  "grp_fulfillment": "Fulfillment",
  "grp_integrations": "Integrations",
  "grp_reports": "Reports",
  "grp_promotion": "Promotion",
  "grp_admin": "Admin",
  "tag_soon": "Soon",
  "crumb_operations": "Operations",
  "crumb_fulfillment": "Fulfillment",
  "crumb_integrations": "Integrations",
  "title_orders": "Orders",
  "title_order_detail": "Order Detail",
  "title_split": "Split Orders",
  "title_returns": "Returns",
  "search_orders": "Paste order IDs or search name…",
  "search_returns": "Search order ID, return ID…",
  "f_all_mkp_status": "All marketplace statuses",
  "f_all_mkp": "All marketplaces",
  "f_all_status": "All statuses",
  "f_all_seller": "All sellers",
  "f_cod": "COD",
  "f_prepaid": "Prepaid",
  "f_date_from": "From",
  "f_date_to": "To",
  "f_date_today": "Today",
  "f_date_7d": "Last 7 days",
  "f_date_month": "This month",
  "btn_refresh": "Refresh",
  "btn_export": "Export",
  "btn_clear_filters": "Clear filters",
  "btn_filters": "Filters",
  "chip_stage": "Stage: {{v}}",
  "chip_label": "Label: {{v}}",
  "awb_missing": "missing",
  "awb_present": "present",
  "chip_sof": "SOF: {{v}}",
  "sof_only": "only",
  "sof_excluded": "excluded",
  "chip_courier": "Courier: {{v}}",
  "chip_ship_by": "Ship by: {{v}}",
  "ship_by_overdue": "overdue",
  "ship_by_today": "today",
  "ship_by_next_24h": "next 24 h",
  "chip_gift_only": "GWP gift orders",
  "chip_gift_none": "No GWP gift",
  "btn_new_order": "New order",
  "kpi_total": "Orders",
  "kpi_received": "Received",
  "kpi_in_fulfillment": "In fulfillment",
  "kpi_exceptions": "Exceptions",
  "kpi_splits": "Split parents",
  "kpi_labels": "Total labels",
  "th_order_date": "Order Date",
  "th_order": "Order",
  "th_marketplace": "Marketplace",
  "th_channel": "Channel",
  "th_marketplace_status": "Marketplace Status",
  "th_created": "Created",
  "th_customer": "Customer",
  "ship_in": "in {{v}}",
  "ship_overdue": "{{v}} overdue",
  "h_short": "{{n}}h",
  "d_short": "{{n}}d",
  "th_items": "Items",
  "th_total": "Total",
  "th_currency": "Currency",
  "th_status": "Status",
  "th_payment": "Payment",
  "th_source": "Source",
  "th_actions": "",
  "awaiting_settlement": "Awaiting settlement",
  "awaiting_settlement_note": "Updated after the settlement feed lands.",
  "bundle_qty_breakdown": "{{multiplicity}} per pack × {{qty}} ordered = this total",
  "unconfirmed_price_tooltip": "Provisional — pending settlement confirmation",
  "customer_not_provided": "Not provided by marketplace",
  "customer_not_provided_note": "The marketplace order API doesn't include customer details — this is a system constraint, not a bug.",
  "st_received": "Received",
  "st_reserved": "Reserved",
  "st_picked": "Confirm pick",
  "st_packed": "Packed",
  "st_shipped": "Shipped",
  "st_delivered": "Delivered",
  "st_cancelled": "Cancelled",
  "st_returned": "Returned",
  "st_superseded": "Superseded",
  "drawer_stage_picked": "Picked",
  "drawer_title": "Filters",
  "drawer_subtitle": "Filters stay in the URL — share the link",
  "drawer_group_fulfilment": "Fulfilment",
  "drawer_group_order": "Order",
  "drawer_stage": "Stage",
  "drawer_label": "Label",
  "awb_missing_title": "Missing",
  "awb_present_title": "Present",
  "drawer_sof": "Seller Own Fleet",
  "sof_excluded_title": "Exclude",
  "sof_only_title": "Only",
  "drawer_courier": "Courier",
  "drawer_ship_by": "Ship by",
  "ship_by_overdue_title": "Overdue",
  "ship_by_today_title": "Today",
  "ship_by_next_24h_title": "Next 24 h",
  "drawer_gift": "GWP gift",
  "drawer_payment_channel": "Payment channel",
  "drawer_seller": "Seller",
  "any": "Any",
  "btn_reset": "Reset",
  "btn_apply": "Apply",
  "btn_apply_n": "Apply {{n}}",
  "act_view": "View detail",
  "back_to_orders": "Back to orders",
  "back_to_splits": "Back to split orders",
  "sec_summary": "Order summary",
  "sec_items": "Items",
  "sec_money": "Payment breakdown",
  "sec_timeline": "Fulfillment timeline",
  "status_section_marketplace": "Marketplace status",
  "status_log_empty": "No status changes recorded yet.",
  "status_marketplace_csv_only_note": "Waiting on the marketplace's API — sourced from CSV import.",
  "lbl_sale_order": "Sale order ID",
  "lbl_marketplace": "Marketplace",
  "lbl_seller": "Seller",
  "lbl_customer": "Customer",
  "lbl_phone": "Phone",
  "lbl_created": "Created",
  "lbl_payment": "Payment",
  "lbl_status": "Status",
  "lbl_tracking": "Tracking / AWB",
  "lbl_pending": "Pending",
  "oi_title": "Order Information",
  "ci_title": "Customer Information",
  "oi_number": "Order Number",
  "oi_package_no": "Package #",
  "oi_marketplace_order_no": "Marketplace Order #",
  "oi_marketplace_status": "Marketplace Status",
  "oi_created": "Order Created Date",
  "oi_updated": "Latest Update DateTime",
  "oi_seller": "Seller ID",
  "oi_seller_name": "Seller Name",
  "oi_seller_display": "Seller Name",
  "seller_option": "{{name}} ({{id}})",
  "oi_channel": "Channel",
  "oi_courier": "Courier",
  "oi_tracking": "Tracking / AWB",
  "oi_warehouse": "Warehouse",
  "oi_paid_at": "Paid",
  "oi_shipped_at": "Shipped",
  "oi_completed_at": "Completed",
  "oi_created_by": "Created By",
  "ci_name": "Customer Name",
  "ci_phone": "Customer Phone",
  "ci_email": "Customer Email",
  "ci_social": "Customer Social Name",
  "ci_billing": "Customer Billing Name",
  "ci_ship_addr": "Shipping Address",
  "ci_bill_addr": "Billing Address",
  "pt_image": "Image",
  "img_preview_hint": "Click to enlarge",
  "img_none": "No image",
  "pt_sku": "SKU",
  "pt_type": "Type",
  "pt_expand": "Show base components",
  "pt_collapse": "Hide base components",
  "pt_freebies": "Freebies",
  "pt_product": "Product Name",
  "pt_qty": "Quantity",
  "pt_selling": "Selling Price",
  "pt_discount": "Discount",
  "pt_total": "Total",
  "pay_title": "Payment Details",
  "pay_method": "Payment Method",
  "pay_channel": "Payment Channel",
  "pay_status": "Payment Status",
  "pay_reference": "Payment Reference",
  "pay_currency": "Currency",
  "tot_title": "Order Totals",
  "tot_sub": "Sub Total",
  "tot_discount": "Total Discount",
  "tot_item_disc": "Item Discount",
  "tot_voucher": "Voucher",
  "tot_shipping": "Shipping Fee",
  "tot_grand": "Grand Total",
  "tot_reconcile_ok": "Totals reconcile with the item lines",
  "tot_mismatch": "Totals do not reconcile — order is in manual review",
  "stl_title": "Settlement",
  "stl_none": "No settlement data from {{mkp}} yet.",
  "stl_buyer_paid": "Buyer Paid",
  "stl_fees": "Marketplace Fees",
  "stl_net_payout": "Net Payout",
  "stl_settled_at": "Settled {{date}}",
  "stl_gross_mismatch": "Marketplace settlement gross differs from the order total",
  "th_sku": "Sino SKU",
  "th_product": "Product",
  "th_qty": "Qty",
  "th_unit": "Unit price",
  "th_line": "Line total",
  "tag_gift": "GIFT",
  "tag_bundle": "BUNDLE",
  "tag_combo": "Combo",
  "tag_unmapped": "SKU unmapped",
  "m_original": "Original amount",
  "m_discount": "Discount",
  "m_shipping": "Shipping fee",
  "m_order_fee": "Order fee",
  "m_total": "Total amount",
  "inv_ok": "Invariant ✓",
  "btn_view_payload": "View raw payload",
  "split_of": "Split {{n}} of {{m}}",
  "view_siblings": "View all splits",
  "related_orders_banner_text": "This order is 1 of {{n}} packages from the same marketplace order ({{saleOrderId}})",
  "related_orders_view_package": "View package {{index}}",
  "tl_received": "Order received",
  "tl_reserved": "Stock reserved",
  "tl_picked": "Sino confirmed pick (CONFIRM_PICK)",
  "tl_packed": "Packed at warehouse",
  "tl_packed_handover": "Handed over to courier · {{time}}",
  "tl_shipped": "Shipped (reported by marketplace)",
  "tl_shipped_awb": "Shipped (reported by marketplace) · {{awb}}",
  "tl_delivered": "Delivered (reported by marketplace)",
  "tl_superseded": "Order superseded — replaced by a newer version",
  "tl_cancelled": "Order cancelled — lock/reserve released",
  "pd_title": "Order payload",
  "pd_sub": "Raw inbound event (mock adapter)",
  "th_sale_order": "Sale order",
  "th_split_count": "Splits",
  "th_labels": "Labels",
  "split_rules": "Applied split rules",
  "th_label": "Label",
  "rule_carton": "Carton limit (max 3)",
  "rule_label": "Label limit (max 5)",
  "rule_brand": "Brand + MOQ grouping",
  "rule_bundle": "Bundle separation",
  "sec_split_overview": "Split overview",
  "split_intro": "This order was split by the Split Order Module (PRD §4.15) before being pushed to Sino. Each label is fulfilled independently.",
  "so_detail_title": "Split Order Detail",
  "so_original": "Original order",
  "so_customer": "Customer",
  "so_total_across": "{{total}} across {{n}} labels",
  "so_label": "Label",
  "so_split_n": "Split {{n}} of {{m}}",
  "so_purpose": "Why split: Sino (LSC) warehouse caps each shipping label at 3 cartons and each order at 5 labels; bundle SKUs ship on their own label. The module computes this label layout before the order is pushed to Sino.",
  "trace_title": "Split rule trace (audit)",
  "trace_own": "→ own label",
  "trace_group": "→ grouped into label {{n}}",
  "trace_overflow": "→ overflow into label 5",
  "rule_1": "Rule 1 · Carton limit",
  "rule_2": "Rule 2 · Label limit",
  "rule_3": "Rule 3 · Brand + MOQ",
  "rule_4": "Rule 4 · Bundle separation",
  "rule_5": "Rule 5 · Carton-min-1",
  "rule_6": "Rule 6 · Pack→carton",
  "rule_7": "Rule 7 · Label 5 overflow",
  "th_return_id": "Return ID",
  "th_reason": "Reason",
  "th_refund": "Refund",
  "th_return_status": "Status",
  "th_updated": "Updated",
  "ret_shop_id": "Shop ID",
  "return_detail": "Return detail",
  "sec_return_items": "Returned items",
  "return_stock_note": "Stock is not changed by this record. On-hand is updated only when Sino WMS confirms the goods are back (RETURNED).",
  "rd_order": "Order ID",
  "rd_return": "Return ID",
  "rd_amount": "Refund amount",
  "rd_reason": "Reason",
  "rd_seller": "Seller",
  "rd_tracking": "Tracking",
  "th_seller": "Seller",
  "oi_channel_status": "Channel Status",
  "exc_filter": "Exceptions only",
  "sel_count": "{{n}} selected",
  "bulk_export": "Export selected",
  "bulk_clear": "Clear",
  "t_bulk_export": "Exporting {{n}} selected order(s).",
  "title_orders_export": "Orders Export",
  "oe_config": "Export configuration",
  "oe_range": "Date range",
  "oe_date_from": "Date from",
  "oe_date_to": "Date to",
  "oe_columns": "Columns",
  "oe_generate": "Generate export",
  "oe_done": "Exported {{count}} orders.",
  "oe_empty": "No orders match the selected filters.",
  "oe_failed": "Export failed. Please try again.",
  "attempts": "{{n}} attempts",
  "btn_retry_now": "Retry now",
  "t_copied": "Payload copied to clipboard.",
  "units": "units",
  "per_label": "Items on this label",
  "cb_select_all": "Select all",
  "cb_select_order": "Select order {{id}}",
  "loading_orders": "Loading orders…",
  "empty_no_orders": "No orders found",
  "empty_no_orders_desc": "Try adjusting your filters.",
  "empty_no_match": "No orders match these filters",
  "empty_no_match_desc": "Try removing a filter, or clear them all.",
  "empty_no_returns": "No returns found",
  "empty_no_returns_desc": "Try adjusting your filters.",
  "empty_order_not_found": "Order not found",
  "empty_order_not_found_desc": "This order may have been removed or the link is incorrect.",
  "t_bulk_fail": "Bulk action failed — please try again.",
  "sync_last": "Last update {{rel}}",
  "sync_in_progress": "Syncing…",
  "sync_never": "Never synced",
  "refresh_syncing": "Syncing…",
  "refresh_synced": "Synced {{rel}}",
  "refresh_never": "Not yet synced",
  "refresh_not_found": "Not found on the marketplace",
  "refresh_failed": "Sync failed",
  "refresh_not_configured": "Marketplace not connected",
  "refresh_not_available": "Marketplace refresh isn't available yet",
  "btn_reconnect": "Reconnect",
  "sync_menu": "Sync",
  "sync_menu_label": "Sync orders from marketplaces",
  "sync_window_1h": "Last hour",
  "sync_window_6h": "Last 6 hours",
  "sync_window_1d": "Last day",
  "sync_window_7d": "Last 7 days",
  "sync_window_30d": "Last 30 days",
  "sync_window_90d": "Last 90 days",
  "sync_confirm_title": "Sync {{window}}?",
  "sync_confirm_body": "This can take several minutes and runs in the background.",
  "sync_confirm_ok": "Start sync",
  "sync_confirm_cancel": "Cancel",
  "sync_syncing": "Syncing…",
  "sync_cancel": "Cancel",
  "sync_chip_queued": "{{mkp}} …",
  "sync_chip_running": "{{mkp}} {{ingested}}/{{fetched}}",
  "sync_chip_done": "{{mkp}} ✓",
  "sync_chip_failed": "{{mkp}} ✗ {{error}}",
  "sync_chip_cancelled": "{{mkp}} ✗ cancelled",
  "t_sync_done_one": "Synced {{count}} order",
  "t_sync_done_other": "Synced {{count}} orders",
  "t_sync_partial_one": "Sync finished with errors — {{count}} order synced",
  "t_sync_partial_other": "Sync finished with errors — {{count}} orders synced",
  "t_sync_mkp_failed": "{{mkp}}: {{error}}",
  "t_sync_cancelled_one": "Sync cancelled — {{count}} order synced",
  "t_sync_cancelled_other": "Sync cancelled — {{count}} orders synced",
  "t_sync_unavailable": "Sync isn't available right now — try again in a minute",
  "t_sync_start_fail": "Couldn't start sync — try again",
  "t_sync_cancel_fail": "Couldn't cancel — the sync may have already finished",
  "btn_resolve": "Resolve",
  "btn_open_seller_center": "Open Seller Center",
  "btn_open_inventory": "Open Inventory",
  "attention": {
    "tab": "Needs attention",
    "any": "Any",
    "all": "All",
    "tablist_label": "Order view"
  },
  "reason": {
    "oversold": "Oversold",
    "buyer_cancel_requested": "Buyer cancel request"
  },
  "banner": {
    "oversold": {
      "title": "Oversold",
      "body": "SKU {{sku}} ({{mkp}}) — sellable now {{sellable}} · on-hand {{on_hand}} · reserved {{reserve}}."
    },
    "buyer_cancel": {
      "title": "Buyer requested cancellation",
      "body": "{{mkp}} waits for your answer until {{by}}. Answer the request in Seller Center."
    }
  },
  "resolve": {
    "title": "Resolve: {{reason}}",
    "question": "What did you do?",
    "other_note": "Other",
    "confirm": "Confirm",
    "fail": "Resolve failed — please try again."
  },
  "activity": {
    "title": "Activity",
    "view_all": "View all in Audit log",
    "add_note": "Add a note…",
    "post": "Post note",
    "older": "Show {{n}} older events",
    "src": {
      "marketplace": "Marketplace",
      "warehouse": "Warehouse",
      "atlas": "Atlas",
      "people": "People"
    },
    "category": {
      "marketplace": "Marketplace",
      "warehouse": "Warehouse",
      "stock": "Stock",
      "note": "Note",
      "settlement": "Settlement",
      "atlas": "Atlas"
    },
    "today": "Today",
    "yesterday": "Yesterday",
    "open_audit": "Open in Audit log",
    "view_raw_payload": "View marketplace payload",
    "all": "All",
    "empty": "No activity yet",
    "delete_note": "Delete note",
    "show_system_events": "Show {{n}} system events",
    "hide_system_events": "Hide system events",
    "error": "Could not load the activity feed. Try again.",
    "only_system": "Only {{n}} system events so far — use \"Show system events\" to see them.",
    "repeated": "{{count}} attempts",
    "repeated_title": "The warehouse has tried {{count}} times since {{since}}; Atlas refused every time."
  },
  "warn_oversold": "Oversold — review before shipping",
  "tip_label_printed": "printed",
  "tip_label_missing": "missing",
  "tip_own_fleet": "Own fleet",
  "tip_label_missing_icon": "Label missing",
  "tip_fulfilment_label": "Fulfilment",
  "tip_label_label": "Label",
  "tip_ship_by_label": "Ship by",
  "tip_courier_label": "Courier",
  "tip_fleet_label": "Fleet",
  "return_status_label": {
    "RETURN_OR_REFUND_REQUEST_COMPLETE": "Return/refund complete",
    "RETURN_OR_REFUND_REQUEST_CANCEL": "Return/refund cancelled",
    "RETURN_OR_REFUND_REQUEST_PENDING": "Return/refund pending",
    "REQUEST_INITIATE": "Return requested",
    "REQUESTED": "Requested",
    "ACCEPTED": "Accepted",
    "REFUND_SUCCESS": "Refunded",
    "RETURNED": "Returned",
    "CANCELLED": "Cancelled",
    "REJECTED": "Rejected",
    "CLOSED": "Closed",
    "JUDGING": "Under review",
    "AWAITING_BUYER_SHIP": "Awaiting buyer shipment",
    "BUYER_SHIPPED_ITEM": "Buyer shipped item",
    "TO_RETURN": "To return",
    "COMPLETED": "Completed",
    "PROCESSING": "Processing"
  }
}
